import Cookies from 'js-cookie';
import { TOKEN } from 'constants/cookies';
import { useQuery } from 'react-query';

import axios from 'utilities/axios';

const Api = {
  BUYER_TOKEN: {
    name: 'buyer-token',
    url: 'customers/token',
  },
  BALANCE_SETTING: {
    name: 'balance-setting',
    url: 'payments/balance-setting',
  },
};

export const useGenerateBuyerToken = () => {
  const access_token = Cookies.get(TOKEN);
  return useQuery([Api.BUYER_TOKEN.name, access_token], async () => {
    const { data } = await axios.get(Api.BUYER_TOKEN.url);
    return data.token;
  });
};

export const useGetApiKeyAndBalanceScriptSdk = () => {
  const access_token = Cookies.get(TOKEN);
  return useQuery([Api.BALANCE_SETTING.name, access_token], async () => {
    const { data } = await axios.get(Api.BALANCE_SETTING.url);
    return data;
  });
};

const useBalanceSdk = () => {
  return {
    balanceWidget: {
      balanceSDK: window.balanceSDK,
    },
  };
};

export default useBalanceSdk;
